import {
	removeVariableFromGroup,
	ActionTypes,
	RemoveVariableFromGroupAction
} from 'store/data/variables';
import { Operation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { ActionPayload } from 'store/types';

export function useRemoveVariableFromGroup(): Operation<
	(payload: ActionPayload<RemoveVariableFromGroupAction>) => void
> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.REMOVE_VARIABLE_FROM_GROUP);

	function handler(payload: ActionPayload<RemoveVariableFromGroupAction>) {
		dispatch(removeVariableFromGroup(payload));
	}

	return [{ loading, error }, handler];
}
